// Intercepts clicks on Dibs' (OrderEasy) "Preorder Now" button so the
// accessory upsell modal shows BEFORE checkout, not just alongside it.
// Scoped to forms containing the Dibs widget specifically, so it never
// touches the site's normal add-to-cart flow, which already triggers the
// same modal correctly via the native cart-update event after the item is
// actually added.
//
// "Preorder Now" submits straight into Dibs' own checkout flow with no
// normal cart-add step to hook into, so this uses a capture-phase listener
// to block the click before Dibs' own handler runs, shows the popup, then
// replays the original click once the popup is dismissed.
(function () {
  document.addEventListener(
    'click',
    (evt) => {
      const button = evt.target.closest('button, [role="button"]');
      if (!button) return;
      if (button.dataset.dibsReplay) return;

      const form = button.closest('form, product-form');
      if (!form || !form.querySelector('.lb-ordereasy-product-widget')) return;

      const label = (button.textContent || '').trim().toLowerCase();
      if (!label.includes('preorder')) return;

      const modal = document.querySelector('#AccessoryUpsellModal');
      if (!modal || typeof modal.open !== 'function') return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      // Preordering still touches Shopify's cart behind the scenes (Dibs is
      // built on selling plans), which fires the same cart-update event the
      // modal normally listens for to auto-open on a plain add-to-cart. That
      // would pop the modal a second time right after this replay — so we
      // suppress that listener for a few seconds while the replay resolves.
      window.__dibsUpsellHandled = true;

      const replay = () => {
        modal.removeEventListener('accessory-upsell:closed', replay);
        button.dataset.dibsReplay = 'true';
        button.click();
        delete button.dataset.dibsReplay;
        setTimeout(() => {
          window.__dibsUpsellHandled = false;
        }, 3000);
      };

      modal.addEventListener('accessory-upsell:closed', replay, { once: true });
      modal.open();
    },
    true
  );
})();
